// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { EngagementStatus } from "../../data/talent-core/engagement-status";
import { ResourceSearchResult } from "../result/resource-search-result";
import { ProductionSearchResult } from "../result/production-search-result";
import { EngagementDocument } from "./documents/engagement-document";
import { ItemEnvelope } from "./base/item-envelope";

export class EngagementEnvelope extends ItemEnvelope {
	public constructor(jsonEnvelope: any) {
		super(jsonEnvelope, "Engagement");
		if (jsonEnvelope) {
			this.EngagementStatuses = jsonEnvelope.EngagementStatuses;
			this.AvailableResources = jsonEnvelope.AvailableResources;
			this.AvailableProductions = jsonEnvelope.AvailableProductions;
			this.Document = jsonEnvelope.Document;
			this.CreatedOnUTC = jsonEnvelope.CreatedOnUTC;
			this.CreateUserUID = jsonEnvelope.CreateUserUID;
			this.ModifiedOnUTC = jsonEnvelope.ModifiedOnUTC;
			this.ModifyUserUID = jsonEnvelope.ModifyUserUID;
		}
	}
	public EngagementStatuses: EngagementStatus[] = [];
	public AvailableResources: ResourceSearchResult[] = [];
	public AvailableProductions: ProductionSearchResult[] = [];
	public override Document: EngagementDocument = new EngagementDocument();
	public override get ItemId(): number { return this.Document.Item.EngagementId; }
	public override get ItemName(): string { return this.Document.Item.EngagementId.toString(); }
}